/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderListItem
 */
export interface ProviderListItem {
    /**
     * 
     * @type {string}
     * @memberof ProviderListItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProviderListItem
     */
    label?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderListItem
     */
    isActive?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderListItem
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderListItem
     */
    isMixAndMatchProvider?: boolean;
}

export function ProviderListItemFromJSON(json: any): ProviderListItem {
    return ProviderListItemFromJSONTyped(json, false);
}

export function ProviderListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'isMixAndMatchProvider': !exists(json, 'isMixAndMatchProvider') ? undefined : json['isMixAndMatchProvider'],
    };
}

export function ProviderListItemToJSON(value?: ProviderListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'label': value.label,
        'isActive': value.isActive,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
        'isMixAndMatchProvider': value.isMixAndMatchProvider,
    };
}


